// extracted by mini-css-extract-plugin
export default {"text":"priceText_text__WQ5Lf","symbol":"priceText_symbol__lVBl4"};